<template>
  <div class="address-form-container clearfix">
    <div class="address-form">
      <div class="address form-group col-sm-12">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">ที่อยู่</span>
          <input
            type="text"
            class="form-control input-sm"
            :class="{ 'bd-red': validation.address }"
            v-model="data.address"
            :disabled="disabled || _.get(configDisabled, 'address', false)"
          />
        </div>
      </div>
      <div class="country form-group col-sm-6">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">ประเทศ</span>
          <input
            type="text"
            class="form-control input-sm"
            :class="{ 'bd-red': validation.country }"
            v-model="data.country"
            disabled
          />
        </div>
      </div>
      <div class="province form-group col-sm-6">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">จังหวัด</span>
          <Dropdown
            class="form-control input-sm"
            :class="{ 'bd-red': validation.province }"
            v-model="data.province"
            :selectedValue="data.province"
            :options="renderProvinceOptions"
            :disabled="disabled || _.get(configDisabled, 'province', false)"
          />
        </div>
      </div>
      <div class="district form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">เขต/อำเภอ</span>
          <Dropdown
            class="form-control input-sm"
            :class="{ 'bd-red': validation.district }"
            v-model="data.district"
            :selectedValue="data.district"
            :options="renderDistrictOptions"
            :disabled="disabled || _.get(configDisabled, 'district', false)"
          />
        </div>
      </div>
      <div class="subdistrict form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">แขวง/ตำบล</span>
          <Dropdown
            class="form-control input-sm"
            :class="{ 'bd-red': validation.subdistrict }"
            v-model="data.subdistrict"
            :selectedValue="data.subdistrict"
            :options="renderSubDistrictOptions"
            :disabled="disabled || _.get(configDisabled, 'subdistrict', false)"
          />
        </div>
      </div>
      <div class="postal-code form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">รหัสไปรษณีย์</span>
          <input
            type="text"
            class="form-control input-sm"
            :class="{ 'bd-red': validation.postalCode }"
            v-model="data.postalCode"
            disabled
          />
        </div>
      </div>
      <div class="home-phone form-group col-sm-6">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">โทรศัพท์บ้าน</span>
          <input
            type="tel"
            class="form-control input-sm"
            v-model="data.homePhone"
            maxlength="9"
            :disabled="disabled || _.get(configDisabled, 'homePhone', false)"
          />
        </div>
      </div>
      <div class="mobile-phone form-group col-sm-6">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">โทรศัพท์มือถือ</span>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{ 'bd-red': validation.mobilePhone }"
            v-model="data.mobilePhone"
            maxlength="10"
            :disabled="disabled || _.get(configDisabled, 'mobilePhone', false)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import Dropdown from '@/components/Dropdown'
import API, { HOMEPAGE_URL } from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

export default {
  name: 'selectedaddress',
  data: () => ({
    district: [],
    subDistrict: [],
  }),
  props: {
    data: {
      type: Object,
      required: true,
    },
    isSameAddress: Boolean,
    validation: Object,
    configDisabled: Object,
    disabled: Boolean,
  },
  components: {
    Dropdown,
  },
  computed: {
    renderProvinceOptions() {
      const provinceInformation = this.provinceOptions.data

      const provinceOptionsList = provinceInformation.map(data => ({
        value: data.id,
        description: data.name,
      }))

      if (this.data.province) {
        return provinceOptionsList
      }

      return [{ value: '', description: 'กรุณาเลือกจังหวัด' }, ...provinceOptionsList]
    },
    renderDistrictOptions() {
      const districtInformation = this.district

      const districtOptionsList = districtInformation.map(data => ({
        value: data.amphoe_id,
        description: data.name,
      }))

      if (this.data.district) {
        return districtOptionsList
      }

      return [{ value: '', description: 'กรุณาเลือกเขต/อำเภอ' }, ...districtOptionsList]
    },
    renderSubDistrictOptions() {
      const subDistrictInformation = this.subDistrict

      const subDistrictOptionsList = subDistrictInformation.map(data => ({
        value: data.id,
        description: data.name,
      }))

      if (this.data.subdistrict) {
        return subDistrictOptionsList
      }

      return [{ value: '', description: 'กรุณาเลือกแขวง/ตำบล' }, ...subDistrictOptionsList]
    },
    ...mapGetters({
      provinceOptions: 'provinceInformation',
    }),
  },
  watch: {
    isSameAddress() {
      if (this.isSameAddress) {
        const provinceId = this.data.province
        const districtId = this.data.district

        this.getDistrictInformation(provinceId)
        this.getSubDistrictInformation(provinceId, districtId)
      } else {
        this.district = []
        this.subDistrict = []
      }
    },
    'data.province'(provinceId) {
      if (provinceId) {
        if (!this.isSameAddress) {
          this.district = []
          this.subDistrict = []

          if (!this.data.isApiData) {
            this.data.district = ''
            this.data.subdistrict = ''
            this.data.postalCode = ''
          }

          this.getDistrictInformation(provinceId)
        }
      }
    },
    'data.district'(districtId) {
      if (districtId) {
        if (!this.isSameAddress) {
          this.subDistrict = []

          if (!this.data.isApiData) {
            this.data.subdistrict = ''
            this.data.postalCode = ''
          }

          const provinceId = this.data.province

          if (provinceId && districtId) {
            this.getSubDistrictInformation(provinceId, districtId)
          }
        }
      }
    },
    'data.subdistrict'(subDistrictId) {
      if (subDistrictId) {
        if (!this.isSameAddress) {
          const provinceId = this.data.province
          const districtId = this.data.district

          this.data.isApiData = false

          if (!this.data.postalCode) {
            if (provinceId && districtId && subDistrictId) {
              const subDistrictObject = _.find(
                this.subDistrict,
                subDistrictData => subDistrictData.id === subDistrictId,
              )

              this.data.postalCode = subDistrictObject.postcode
            }
          }
        }
      }
    },
  },
  methods: {
    getDistrictInformation(provinceId) {
      this.$http
        .get(API.ADDRESS.DISTRICT(provinceId), {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        })
        .then(res => res.json())
        .then(
          res => {
            this.district = res.result.amphoe
          },
          error => {
            const { status } = error

            if (status === 401) {
              this.$session.destroy()

              window.location.href = HOMEPAGE_URL
            }

            if (status === 403) {
              this.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })
            }
          },
        )
    },
    getSubDistrictInformation(provinceId, districtId) {
      this.$http
        .get(API.ADDRESS.SUB_DISTRICT(provinceId, districtId), {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        })
        .then(res => res.json())
        .then(
          res => {
            this.subDistrict = res.result.tambon
          },
          error => {
            const { status } = error

            if (status === 401) {
              this.$session.destroy()

              window.location.href = HOMEPAGE_URL
            }

            if (status === 403) {
              this.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })
            }
          },
        )
    },
  },
}
</script>

<style lang="scss">
.address-form-container {
  .address-form {
    .address-line {
      .label-text,
      .address-line-input {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
